export default class Video {
    constructor(el) {
        this.el = el;
        this.initTranscription();
    }

    initTranscription() {
        const button = this.el.querySelector('.video-transcription__toggle');
        const content = this.el.querySelector('.video-transcription__content');

        if (!button || !content) return;

        button.addEventListener('click', () => {
            const isOpen = this.el.classList.toggle('is-open');

            button.setAttribute('aria-expanded', isOpen);
            content.hidden = !isOpen;
        });
    }
}
